export const tabEnum = {
  SITE_DETAILS: 0,
  SERVING_CONFIG: 1,
  CHARGE_LIMITS: 2,
};

export const RestrictionType = {
  None: 0,
  Site: 1,
};

export const ChargeTypeMode = {
  NoRestrictions: 0,
  MaxChargeAmount: 1,
  NumberOfMeals: 2,
};

export const restrictionsOptions = [
  { label: 'No Restrictions', value: 'N' },
  { label: 'Not to Exceed', value: 'Y' },
];

export const frequencyOptions = [
  { label: 'Per Day', value: 'D' },
  { label: 'Per Week', value: 'W' },
  { label: 'Per Month', value: 'M' },
];



// WEBPACK FOOTER //
// ./src/pages/sitesetup/helpers/SiteSetupConstants.js